import React, { FormEvent, useState } from 'react';
import './TournamentProtectedAccess.scss';

interface Props {
   resourceName: string;
   resourceType: 'school site' | 'school big screen' | 'union site' | 'tournament';
   onSubmit: (password: string) => Promise<{ isMatch: boolean }>;
   onUnlocked: () => void;
}

const TournamentProtectedAccess: React.FC<Props> = ({ resourceName, resourceType, onSubmit, onUnlocked }) => {
   const [password, setPassword] = useState('');
   const [error, setError] = useState('');
   const [isChecking, setIsChecking] = useState(false);

   const submit = async (event: FormEvent) => {
      event.preventDefault();
      if (!password || isChecking) return;
      setIsChecking(true);
      setError('');
      try {
         const result = await onSubmit(password);
         if (result.isMatch) onUnlocked();
         else setError('The password is incorrect. Please try again.');
      } catch {
         setError('We could not check the password. Please try again.');
      } finally {
         setIsChecking(false);
      }
   };

   return (
      <main className='tournamentProtectedAccess'>
         <form onSubmit={submit}>
            <div className='tournamentProtectedAccess__icon' aria-hidden='true'>
               <svg viewBox='0 0 24 24'>
                  <rect x='5' y='10' width='14' height='10' rx='2' />
                  <path d='M8 10V7a4 4 0 0 1 8 0v3' />
               </svg>
            </div>
            <span>Protected {resourceType}</span>
            <h1>{resourceName}</h1>
            <p>Enter the password to continue.</p>
            <label>
               <span>Password</span>
               <input
                  type='password'
                  value={password}
                  autoFocus
                  autoComplete='current-password'
                  aria-invalid={Boolean(error)}
                  onChange={event => {
                     setPassword(event.target.value);
                     if (error) setError('');
                  }}
               />
            </label>
            {error ? <div className='tournamentProtectedAccess__error' role='alert'>{error}</div> : null}
            <button type='submit' disabled={!password || isChecking}>
               {isChecking ? 'Checking…' : `Open ${resourceType}`}
            </button>
         </form>
      </main>
   );
};

export default TournamentProtectedAccess;
